import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        as: 'span',
        padding: `${remCalc(6)} ${remCalc(8)}`,
        textStyle: 'body-xxsmall',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        color: 'label.text.primary',
        backgroundColor: 'label.background.primary',
        borderRadius: 'medium-1',
        whiteSpace: 'nowrap',
        minHeight: remCalc(24),
        backdropFilter: `blur(${remCalc(4)})`,
        textAlign: 'center',
    },
    variants: {
        light: {color: 'label.text.primary', backgroundColor: 'label.background.primary'},
        violet: {
            color: 'text.inverse',
            backgroundColor: 'text.violet',
        },
        coupon: {
            color: 'text.success',
            backgroundColor: 'background.success',
            fontStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        grey: {color: 'label.text.disable', backgroundColor: 'label.background.disable'},
        error: {color: 'text.danger', backgroundColor: 'background.danger'},
        priceInfo: {
            color: 'foreground.neutral.inverse',
            backgroundColor: 'background.neutral.blue',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            boxShadow: `inset 0 0 0 1px color-mix(var(--chakra-colors-background-neutral-blue), white 40%)`,
        },
        promoInfo: {
            color: 'foreground.neutral.inverse',
            backgroundColor: 'background.positive.hover',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            boxShadow: `inset 0 0 0 1px color-mix(var(--chakra-colors-background-positive-hover), white 40%)`,
        },
        pimInfo: {
            color: 'foreground.neutral.inverse',
            backgroundColor: 'background.neutral.bronze',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            boxShadow: `inset 0 0 0 1px color-mix(var(--chakra-colors-background-neutral-bronze), white 40%)`,
        },
        stockInfo: {
            color: 'foreground.neutral.inverse',
            backgroundColor: 'background.neutral.dark',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            boxShadow: `inset 0 0 0 1px color-mix(var(--chakra-colors-background-neutral-dark), white 40%)`,
        },
        bundleSavings: {
            color: 'foreground.neutral.default',
            backgroundColor: 'background.neutral.default',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            borderRadius: 'large',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
        },
        bundle: {
            color: 'foreground.neutral.inverse',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            boxShadow: '0 0 0 1px border.neutral.highlight inset, 0 1px 2px 0 neutral.xs',
            backgroundColor: 'background.neutral.bronzeAlpha',
        },
        addOnBenefit: {
            backgroundColor: 'background.base.default',
            color: 'foreground.neutral.default',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs)',
        },
    },
}
